<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <b-row align-h="start">
            <b-col cols="3"
              ><v-select
                :value="program"
                v-model="program"
                :options="formatOptions"
              ></v-select>
            </b-col>
            <b-col cols="2"
              ><b-form-datepicker
                id="baslangic"
                v-model="baslangic"
                size="md"
                local="en"
                class="mb-2"
                today-variant="danger"
                placeholder="-"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }"
              />
            </b-col>
            <b-col cols="2">
              <b-form-datepicker
                id="bitis"
                v-model="bitis"
                size="md"
                local="en"
                class="mb-2"
                today-variant="danger"
                placeholder="-"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }"
              />
            </b-col>
            <b-col cols="12" md="auto"
              ><vs-button
                style="border-radius: 5px"
                color="success"
                @click="satisListesi()"
                type="gradient"
                >Listele</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto"
              ><vs-button
                style="border-radius: 5px"
                @click="yazdir()"
                type="gradient"
                >Yazdır</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto"
              ><vs-button
                style="border-radius: 5px"
                type="gradient"
                color="danger"
                id="button-with-loading-excel"
                class="vs-con-loading__container"
              >
                <download-excel
                  class="btn btn-default"
                  :data="sipariseGoreUrunListesi"
                  name="excelData.xls"
                  style="padding: 0px !important; color: white"
                >
                  Excel
                </download-excel>
              </vs-button>
            </b-col>
          </b-row>
        </vx-card>

        <vs-table :data="data">
          <template slot="thead">
            <vs-th>Kargo Adı</vs-th>
            <vs-th>Adet</vs-th>
            <vs-th>Çıktı</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].kargoAdi }}
              </vs-td>

              <vs-td>
                {{ data[indextr].adet }}
              </vs-td>
              <vs-td>
                <vs-button
                  color="red"
                  @click="ciktiAl(data[indextr].kargoAdi)"
                  type="filled"
                  >Listele</vs-button
                >
              </vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td></vs-td>
              <vs-td>Toplam M.={{ miktarTopla() }} Adet</vs-td>
              <vs-td></vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <div id="printMe" style="height:200px; overflow:scrool; width:100%;">
      <template id="app">
        <table border="1px;" style="width:100%">
          <tr>
            <td align="right">
              {{ getNow() }}
            </td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </table>
      </template>
      <template>
        <table style="width:100%!important">
          <tr>
            <th sort-key="stokkodu" style="border:1px solid black; padding:3px">
              Sipariş Numarası
            </th>
            <th style="border:1px solid black; padding:3px">Ad Soyad</th>

            <th style="border:1px solid black; padding:3px">Kargo Numarası</th>
          </tr>

          <tr :key="indextr" v-for="(tr, indextr) in sipariseGoreUrunListesi">
            <td style="border:1px solid black; padding:3px">
              {{ tr.siparisNo }}
            </td>
            <td style="border:1px solid black; padding:3px">
              {{ tr.shipFullName }}
            </td>

            <td style="border:1px solid black; padding:3px">
              {{ tr.kargoTakipNo }}
            </td>
          </tr>

          <tr>
            <td style="border:1px solid black; padding:3px"></td>
            <td style="border:1px solid black; padding:3px"></td>
          </tr>
          <tr>
            <td style="border:0px solid black; padding:3px"></td>
            <td style="border:0px solid black; padding:3px"></td>
          </tr>
          <tr>
            <td style="border:0px solid black; padding:3px"></td>
            <td style="border:0px solid black; padding:3px"></td>
          </tr>

          <tr>
            <td style="border:0px solid black; padding:3px">Teslim Eden</td>
            <td style="border:0px solid black; padding:3px">Teslim Alan</td>
          </tr>
        </table>
      </template>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import state from "../../store/state";
import Store from "../../store/store";
export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      data: [],
      sipariseGoreUrunListesi: [],
      baslangic: "",
      formattedDate: "",
      formattedDate1: "",
      bitis: "",
      program: { id: 0, label: "Pazaryeri" },
      check3: "",
      formatOptions: [],
      tabList: []
    };
  },
  created() {
    this.tabList = Store.state.uzum.menuListForTabs;
    this.tabList.forEach((val, index) => {
      this.formatOptions.push({ label: val.name, id: val.name });
    });
  },
  methods: {
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    miktarTopla() {
      var sayi = 0;
      this.data.forEach(element => {
        sayi = sayi + parseInt(element.adet);
      });
      return sayi;
      // this.toplam=parseInt(this.toplam)+parseInt(d)
      // return this.toplam
      //console.log(this.toplam)
    },
    ciktiAl(kargoAdi) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1) + "-" + d.getUTCDate();

      var d1 = new Date(vm.bitis);
      vm.formattedDate1 =
        d1.getUTCFullYear() +
        "-" +
        (d1.getUTCMonth() + 1) +
        "-" +
        d1.getUTCDate();
      // console.log(vm.formattedDate)
      const args = {
        program: this.program.label,
        baslik: "kargoGonderimListesi",
        tarih1: vm.formattedDate,
        tarih2: vm.formattedDate1,
        token: Store.state.tokenId,
        kullaniciId: kargoAdi,
        siparisNo: ""
      };

      soap.createClient(url, function(err, client) {
        client.standartSorguRapor(args, function(err, result) {
          if (result.standartSorguRaporResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.standartSorguRaporResult);
          //console.log(vm.veriler)
          vm.sipariseGoreUrunListesi = vm.veriler;
          // vm.eslesenStokListesi=vm.veriler
        });
      });
    },
    yazdir() {
      this.$htmlToPaper("printMe");
    },
    satisListesi() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      var d = new Date(vm.baslangic);
      vm.formattedDate =
        d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1) + "-" + d.getUTCDate();

      var d1 = new Date(vm.bitis);
      vm.formattedDate1 =
        d1.getUTCFullYear() +
        "-" +
        (d1.getUTCMonth() + 1) +
        "-" +
        d1.getUTCDate();
      // console.log(vm.formattedDate)
      const args = {
        program: this.program.label,
        baslik: "kargoRaporu",
        tarih1: vm.formattedDate,
        tarih2: vm.formattedDate1,
        token: Store.state.tokenId,
        kullaniciId: "",
        siparisNo: ""
      };
      console.log(args);
      soap.createClient(url, function(err, client) {
        client.standartSorguRapor(args, function(err, result) {
          if (result.standartSorguRaporResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.standartSorguRaporResult);
          console.log(vm.veriler);
          vm.data = vm.veriler;
          // vm.eslesenStokListesi=vm.veriler
        });
      });
    }
  },
  components: {
    "v-select": vSelect,
    Datepicker
  }
};
</script>
